import React, { CSSProperties } from 'react';

import classNames from 'classnames';

import styles from './styles.module.scss';

type LoadingSpinnerType = {
	size?: number;
	color?: string;
	stroke?: number;
	className?: string;
	isPrimary?: boolean;
};

const LoadingSpinner: React.FC<LoadingSpinnerType> = ({
	size,
	className,
	color,
	stroke,
	isPrimary = true,
}) => {
	const cssProps = {} as CSSProperties;

	if (size) {
		cssProps.width = size;
		cssProps.height = size;
	}

	if (isPrimary) {
		cssProps.color = 'var(--primary-color)';
	}

	if (color) {
		cssProps.color = color;
	}

	if (stroke) {
		cssProps.borderWidth = stroke;
	}

	return (
		<div className={classNames([styles.wrapper, className])}>
			<div style={cssProps} className={styles.loadingInner}>
				<div style={cssProps} />
				<div style={cssProps} />
				<div style={cssProps} />
				<div style={cssProps} />
			</div>
		</div>
	);
};

export default LoadingSpinner;
